import { useState } from 'react';

function Accordion({ title, children, icon, open = false }) {
  const [isOpen, setIsOpen] = useState(open);

  return (
    <div className="border rounded-lg">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-2">
          {icon && <img src={icon} alt="" className="w-5 h-5" />}
          <h3 className="font-semibold text-gray-800">{title}</h3>
        </div>
        <span className={`transform transition-transform ${isOpen ? 'rotate-180' : ''}`}>
          ▼
        </span>
      </div>
      {isOpen && (
        <div className="p-4 border-t">
          {children}
        </div>
      )}
    </div>
  );
}

export default Accordion;
